import React, {
  ClassAttributes,
  ForwardedRef,
  forwardRef,
  TextareaHTMLAttributes,
  useEffect,
  useState,
} from 'react';
import { CSSObject } from '@emotion/react';
import { wrap, textarea, maxParagraph } from './style';

interface Props
  extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'defaultValue'>,
    ClassAttributes<HTMLTextAreaElement> {
  css?: CSSObject;
  maxLength: number;
}

function MaxTextarea(
  {
    css = {},
    maxLength,
    value: propValue,
    onChange: propHandleChange,
    ...props
  }: Props,
  ref: ForwardedRef<HTMLTextAreaElement>,
) {
  const [value, setValue] = useState('');

  useEffect(() => {
    propValue && setValue(propValue as string);
  }, [propValue]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target;
    if (value.length > maxLength) return;

    setValue(e.target.value);
    propHandleChange?.(e);
  };

  return (
    <div css={wrap}>
      <label css={{ position: 'relative' }}>
        <textarea
          {...props}
          css={{ ...textarea, ...css }}
          value={value}
          onChange={handleChange}
          ref={ref}
        ></textarea>
      </label>
      <p css={maxParagraph}>
        {`${value.length}자`}
        <span>{`/${maxLength}자`}</span>
      </p>
    </div>
  );
}

export default forwardRef(MaxTextarea);
